module.exports = __webpack_public_path__ + "static/Charger_panel-8fb6b12585b3040fb17e2b717c8a6482.png";